import React from "react";
import ProductFirstApp from "./ProductFirstApp";
import {
  Flame, Sun, Sparkles, Soup, Wheat, Utensils, Cookie, Salad, CupSoda, Package,
} from "lucide-react";

const CHIPS = [
  { id: "north-indian",    label: "North Indian",   query: "bhojan",       icon: Flame,    color: "#7f1d1d", bg: "#fecaca" },
  { id: "south-indian",    label: "South Indian",   query: "upma",         icon: Sun,      color: "#78350f", bg: "#fde68a" },
  { id: "faral",           label: "Faral",          query: "faral",        icon: Sparkles, color: "#7c2d12", bg: "#fed7aa" },
  { id: "chinese",         label: "Chinese",        query: "chinese",      icon: Soup,     color: "#831843", bg: "#fbcfe8" },
  { id: "mexican",         label: "Mexican",        query: "mexican",      icon: Salad,    color: "#14532d", bg: "#bbf7d0" },
  { id: "maharashtrian",   label: "Maharashtrian",  query: "modak",        icon: Wheat,    color: "#78350f", bg: "#fef3c7" },
  { id: "sweets",          label: "Sweets",         query: "sweet",        icon: Cookie,   color: "#831843", bg: "#f9a8d4" },
  { id: "snacks",          label: "Snacks",         query: "snack",        icon: Utensils, color: "#78350f", bg: "#fef3c7" },
  { id: "beverages",       label: "Beverages",      query: "coffee",       icon: CupSoda,  color: "#155e75", bg: "#a5f3fc" },
  { id: "tiffin",          label: "Tiffin",         query: "tiffin",       icon: Package,  color: "#1e40af", bg: "#bfdbfe" },
];

export default function Khavayye() {
  return (
    <ProductFirstApp
      appId="khavayye"
      theme={{ primary: "#dc2626", accent: "#f97316" }}
      hero={{
        background: "linear-gradient(135deg,#7f1d1d 0%, #dc2626 50%, #f97316 100%)",
        overlay: "linear-gradient(135deg, rgba(28,8,8,0.45), rgba(28,8,8,0.1))",
        badge: "Khavayye · Home-cooked, tiffin, sweets & caterers",
        searchPlaceholder: "Search: modak, thali, tiffin, ladoo…",
      }}
      chips={CHIPS}
    />
  );
}
